import { setScreen, card, title, subtitle, btn, el, colors, divider } from "./app";
import { showCreateGame } from "./createGame";
import { showJoinGame } from "./joinGame";

export function showLobby(): void {
  const c = card(420);

  // Header
  const header = el("div", { textAlign: "center", marginBottom: "36px" });
  const t = title("Bombball");
  t.style.fontSize = "38px";
  t.style.letterSpacing = "6px";
  header.appendChild(t);
  const tagline = el("p", { margin: "8px 0 0 0", color: colors.muted, fontSize: "13px", letterSpacing: "2px" });
  tagline.textContent = "TACTICAL FANTASY FOOTBALL";
  header.appendChild(tagline);
  c.appendChild(header);

  c.appendChild(divider());

  // Buttons
  const btnCol = el("div", { display: "flex", flexDirection: "column", gap: "12px" });

  const createBtn = btn("⚡  Create Game", "primary");
  createBtn.style.width = "100%";
  createBtn.style.padding = "16px";
  createBtn.style.fontSize = "15px";
  createBtn.addEventListener("click", showCreateGame);

  const joinBtn = btn("🔑  Join Game", "secondary");
  joinBtn.style.width = "100%";
  joinBtn.style.padding = "16px";
  joinBtn.style.fontSize = "15px";
  joinBtn.addEventListener("click", showJoinGame);

  btnCol.appendChild(createBtn);
  btnCol.appendChild(joinBtn);
  c.appendChild(btnCol);

  setScreen(c);
}
